module.exports = __webpack_public_path__ + "img/products_big_can_peach.c9df1cec.png";